jQuery(document).ready(function($) {

    let videoClassName = '.videos--desktop';

    if ($(document).width() < 1440) videoClassName = '.videos--1440';
    if ($(document).width() < 600) videoClassName = '.videos--mobile';

    let modalVideo = $(videoClassName).get(0);

    // otwieranie modala z video
    $('#openModalVideo').click(function(event) {
        $('.modal-video').modal({
            fadeDuration: 200
        });

        modalVideo.play();

        return false;
    });

    // zamykanie modala video
    $('.modal-video').on($.modal.CLOSE, function(event, modal) {

        modalVideo.pause();
        modalVideo.currentTime = 0;

    });


});